<template>
  <v-card class="pr-2" :color="backgroundColor">
    <v-card-title>{{$t('general.customFields')}}</v-card-title>
    <v-divider/>
    <v-card-text class="pt-0 my-2" style="max-height: 300px; overflow-y: auto">
      <v-col cols="12" class="pa-0">
        <v-list-item-group multiple>
          <draggable v-model="localAllColumns"
                     ghost-class="ghost"
                     @start="drag = true"
                     @end="drag = false"
                     handle=".handle">
            <v-list-item v-for="header in localAllColumns" :key="header[valueKey]">
              <v-list-item-action>
                <v-checkbox :value="header"
                            v-model="localSelectedColumns"
                            color="kbDarkBlueText"
                            hide-details/>
              </v-list-item-action>
              <v-list-item-content >
                <v-list-item-title>
                  <span class="text-capitalize kbDarkBlueText--text">
                    {{ header[textKey] || header[valueKey] }}
                  </span>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <i class="fa fa-align-justify handle"/>
              </v-list-item-icon>
            </v-list-item>
          </draggable>
        </v-list-item-group>
      </v-col>
    </v-card-text>

    <v-divider/>

    <v-btn
      color="mainButtons"
      class="mr-2 my-1 ml-4"
      dark
      :loading="loading"
      @click="saveColumns()"
    >{{ $t('orders.save') }}</v-btn>
  </v-card>
</template>

<script>
import arraysAndJsonsHelpers from '@/libs/arraysAndJsonsHelpers'
import draggable from 'vuedraggable'
import _ from 'lodash'
import { mapState } from 'vuex'
export default {
  components: {
    draggable
  },
  computed: {
    ...mapState({
      language: state => state.auth.language
    })
  },
  created () {
    if (this.isComponentOpened) {
      this.setColumnsAsPropColumns()
    }
  },
  data () {
    return {
      drag: false,
      localAllColumns: [],
      localSelectedColumns: []
    }
  },
  methods: {
    saveColumns () {
      const orderedColumns = _.intersectionBy(this.localAllColumns, this.localSelectedColumns, this.valueKey)
      this.$emit('onColumnsChange', { allColumns: this.localAllColumns, selectedColumns: orderedColumns })
      this.closeComponent()
    },
    setColumnsAsPropColumns () {
      this.localAllColumns = arraysAndJsonsHelpers.copyJson(this.allColumnsProp)
      this.localSelectedColumns = arraysAndJsonsHelpers.copyJson(this.selectedColumnsProp)
    },
    closeComponent () {
      this.$emit('closeComponent')
    },
    translateHeaders () {
      for (let i = 0; i < this.localAllColumns.length; i++) {
        const translation = this.localAllColumns[i].translation
        if (translation) {
          this.localAllColumns[i].text = this.$t(translation)
        }
      }
      this.saveColumns()
    }
  },
  props: {
    allColumnsProp: {
      type: Array,
      required: true
    },
    backgroundColor: {
      type: String,
      default: 'kbWhite'
    },
    isComponentOpened: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectedColumnsProp: {
      type: Array,
      required: true
    },
    textKey: {
      type: String,
      default: 'text'
    },
    valueKey: {
      type: String,
      default: 'value'
    }
  },
  watch: {
    isComponentOpened (value) {
      if (value) this.setColumnsAsPropColumns()
    },
    language () {
      this.setColumnsAsPropColumns()
      this.translateHeaders()
    }
  }
}
</script>

<style scoped>
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }
</style>
